import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import type { JSX, ReactNode } from "react";

import { useLanguage } from "@/i18n";
import { useAppSelector } from "@/store/hooks";

import { themeCreator } from "./base";

export type ThemeProviderWrapperProps = {
  children: ReactNode;
  themeNameOverride?: string;
};

export const ThemeProviderWrapper = ({ children, themeNameOverride }: ThemeProviderWrapperProps): JSX.Element => {
  const storeThemeName = useAppSelector((state) => state.theme.themeName);
  const themeName = themeNameOverride ?? storeThemeName;
  const language = useLanguage();
  const theme = themeCreator(themeName, language);

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
